<template>
  <div class="page" @click="closePopup" :style="pageStyle">
    <lottie
      v-show="lottieShow"
      class="light-effect"
      style="width: 100%; height: 100%;"
      :options="anim_options"
      v-on:animCreated="handleAnimation"
    />
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import Lottie from "vue-lottie/src/lottie.vue";
import loading from "@/assets/anim/check/data.json";
import noMakeCheck from '@/assets/anim/check/nomask_data.json';
import _ from "lodash";
import audioManager from "@/utils/audioManager";

export default {
  components:{
    'lottie': Lottie
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    playEffect: {
      type: Boolean,
      default: false,
    },
    pageStyle: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    removeMask: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    isShow: {
      handler(value) {
        // console.log('动画此时的value: ',value);
        if(value)this.animInit();
      },
      immediate: true,
      deep: true,
    },
    playEffect: {
      handler(value) {
        if(value){
          this.playSign = true;
          if(this.lottieShow){
            // audioManager.playEffect("get_token");
          }
        }
      },
      immediate: true,
      deep: true,
    },
    removeMask: {
      handler(value) {
        if(value){
          // 移除蒙版
          this.anim_options.animationData = _.cloneDeep(noMakeCheck);
          this.anim_options.animationData.assets.forEach(item => {
            item.u = '';
            if(item.w && item.h){
              try {
                item.p = require(`@/assets/anim/check/images/${item.p}`);
              } catch (error) {
                console.error(error);
              }
            }
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { playEffect } = props;
    const closeFlower = ref(false);
    const isMove = ref(true);
    const anim_options = { animationData: _.cloneDeep(loading) };
    const lottieShow = ref(false);
    const animNode = ref(null);
    const playSign = ref(false);//记录播放标志
    anim_options.animationData.assets.forEach(item => {
      // 适配动态路径
      item.u = '';
      if(item.w && item.h){
        try {
          item.p = require(`@/assets/anim/check/images/${item.p}`);
        } catch (error) {
          console.error(error);
        }
      }
    })

    onMounted(() => {
      // animInit();
    });

    /**获取Lottie动画节点 */
    const handleAnimation = (anim) => {
      animNode.value = anim;
      animNode.value.stop();
      animNode.value.loop = false;
      animNode.value.play();
    }

    const animInit = () => {
      // console.log('animInit');
      lottieShow.value = true;
      
      // 动画执行完毕后等待1s，若没有监听到则自动关闭
      const animated = document.querySelector(".animated");
      if (animated) {
        animated?.addEventListener("animationend", () => {
          delayClose();
        });
      } else {
        delayClose();
      }
    }

    const delayClose = () => {
      setTimeout(() => {
        closePopup();
        lottieShow.value = false;
      }, 208.3333333);
    };

    const closePopup = () => {
      closeFlower.value = true;
      isMove.value = false;
      if(playSign.value){
        // 播放音频的节点需要通知下一组进行播放
        emit("closeAnim", 'next');
      }else {
        // 普通节点关闭自身处理
        emit("closeAnim", false);
      }
    };
    
    return {
      closeFlower,
      closePopup,
      animInit,
      handleAnimation,
      isMove,
      anim_options,
      lottieShow,
      playSign
    };
  },
};
</script>

<style lang="less" scoped>
@animationTime: 450ms;

.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  // will-change: transform;
  
  //json方式实现
  .light-effect{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 300px;
    height: 300px;
  }
}
</style>
